import React, { useState, useRef } from "react";
import useOutsideClick from "../useOutsideClick";
import { Box } from "@mui/material";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import ArrowDropDown from "@mui/icons-material/ArrowDropDown";
import UIRTMButton from "../UIRTMButton";
import AIAnalytics from "../aiAnalytics/AIAnalytics";

const MappingSidebar = React.memo(({
  mappingState,
  templateFields,
  templateType,
  onSave,
  onGenerate,
  onUpload,
  onFetchIssues,
  downloadLoading,
  saveLoading,
  uploadLoading,
}) => {
  const [showUploadMenu, setShowUploadMenu] = useState(false);
  const uploadRef = useRef(null);
  useOutsideClick({
    refs: [uploadRef],
    enabled: showUploadMenu,
    handler: () => setShowUploadMenu(false),
  });
  
  const requiredFields = React.useMemo(() => 
    templateFields.filter((f) => f.mandatory),
  [templateFields]);

  const isAllRequiredMapped = React.useMemo(() => 
    requiredFields.every((reqField) =>
      mappingState.mappings.some((m) => m.templateId === reqField.id),
    ),
  [requiredFields, mappingState.mappings]);

  const isDisabled = !isAllRequiredMapped;

  return (
    <div className="mapping-sidebar">
      {/* Caption */}
      {isDisabled && (
        <div className="mapping-warning">* Required fields mapping missing</div>
      )}
      <UIRTMButton
        variant="text"
        title={!saveLoading ? "Save Mapping" : "...Saving"}
        loading={saveLoading}
        disabled={isDisabled || saveLoading}
        onClick={onSave}
        icon={<SaveOutlinedIcon sx={{fontSize:"1rem" }}/>}
      />

      <UIRTMButton
        title={!downloadLoading ? "Download" : "...Generating"}
        variant="text"
        icon={<FileDownloadOutlinedIcon sx={{fontSize:"1rem"}}/>}
        loading={downloadLoading}
        disabled={isDisabled || downloadLoading}
        onClick={onGenerate}
      />

      <div className="upload-wrapper" ref={uploadRef}>
        <UIRTMButton
          title={!uploadLoading ? "Upload To" : "...Uploading"}
          icon={<UploadFileIcon sx={{fontSize:"1rem"}}/>}
          endIcon={<ArrowDropDown/>}
          variant="text"
          loading={uploadLoading}
          disabled={isDisabled || uploadLoading}
          onClick={() => setShowUploadMenu((prev) => !prev)}
        />

        {showUploadMenu && (
          <div className="upload-menu">
            <div onClick={() => onUpload("sharedDrive")}>Network Shared Drive</div>
        
          </div>
        )}
      </div>

      <AIAnalytics 
        onFetchData={onFetchIssues} 
        disabled={isDisabled} 
        templateType={templateType} 
      />
    </div>
  );
});

export default MappingSidebar;
